export enum SelectedSitesStep {
  Auth = 1,
  Config = 2,
  Enabled = 3,
}

export class SelectedSitesSteps {
  status: Record<SelectedSitesStep, boolean>;

  constructor(json?: string) {
    this.status = {
      [SelectedSitesStep.Auth]: false,
      [SelectedSitesStep.Config]: false,
      [SelectedSitesStep.Enabled]: false,
    };

    if (json) {
      this.fromJSON(json);
    }
  }

  isAllStepsFalse(): boolean {
    return Object.values(this.status).every((step) => step === false);
  }

  toJSON(): string {
    return JSON.stringify(this.status);
  }

  fromJSON(json: string | undefined): void {
    if (json) {
      const parsed = JSON.parse(json);
      this.status = {
        [SelectedSitesStep.Auth]: Boolean(parsed[SelectedSitesStep.Auth]),
        [SelectedSitesStep.Config]: Boolean(parsed[SelectedSitesStep.Config]),
        [SelectedSitesStep.Enabled]: Boolean(parsed[SelectedSitesStep.Enabled]),
      };
    }
  }
}
